import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rwd",
  "use": "rwd-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 21 21\" id=\"rwd\"><path fill=\"currentColor\" d=\"M16.5 18.797h-3v-5h3zM7.5 18.797h-3v-5h3z\" /><path stroke=\"currentColor\" stroke-width=\".8\" d=\"M16.1 7.397h-2.2v-4.2h2.2zM7.1 7.397H4.9v-4.2h2.2zM13.5 16.298h-6M13.5 5.298h-6\" /><path stroke=\"currentColor\" stroke-width=\".8\" d=\"M10.5 16.298v-11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol